/**
 * Detect mobile browsers where MSAL popup flow is unreliable.
 * Mobile Chrome/Safari open `window.open` as a new tab (breaking the
 * parent-popup handshake) and block third-party cookies during B2C's
 * federated IdP redirect. Use redirect flow on these devices.
 */
export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
